import React, {Fragment} from 'react'
import {connect} from 'dva'
import {routerRedux} from 'dva/router'
import moment from 'moment'
import {parse, stringify} from 'query-string'
import {Button, Card, Divider, Form, Modal, Table} from 'antd'
import styles from "./index.module.less"
import ticketImage from "../../assets/ticket_sale.jpg"
import TicketOrderStatus from "../../components/TicketOrderStatus"
import Info from "./Info"
import {contextPath} from "../../utils/config"

const namespace = 'ticket'

const Component = ({
                     model,
                     loading,
                     location,
                     dispatch,
                     app,
                   }) => {

  location.query = parse(location.search)
  const {query, pathname} = location
  const {list, pagination, modalVisible, currentItem, products} = model
  const {user} = app
  const columns = [
    {
      title: '购票时间',
      dataIndex: 'ticketTime',
      render: (value) => moment(value).format('Y-MM-DD HH:mm:ss'),
    },
    {
      title: '票种',
      dataIndex: 'productName',
    },
    {
      title: '数量(张)',
      dataIndex: 'quantity',
    },
    {
      title: '金额(元)',
      dataIndex: 'price',
    },
    {
      title: '总计(元)',
      dataIndex: 'totalAmount',
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: 120,
      render: (value) => <TicketOrderStatus value={value}/>
    },
    {
      title: '操作',
      width: 180,
      render: (text, record) => {
        const operations = [
          <a onClick={() => handleView(record)} style={{color: '#1685f5'}}>查看详情</a>
        ]
        if (record.status === 0) {
          operations.push(
            <Divider type="vertical"/>,
            <Form style={{display: 'inline'}} onSubmit={() => {
            }} action={`${contextPath}/ticket/order/pay`} method="post" target="_blank">
              <input type="hidden" name="orderId" value={record.orderId}/>
              <input type="hidden" name="payType" value={1}/>
              <Button size="small" type={"danger"} htmlType={"submit"}>立即支付</Button>
            </Form>
          )
        }
        return operations
      },
    },
  ]

  const modalProps = {
    visible: modalVisible,
    maskClosable: false,
    width: 840,
    title: currentItem && `订单号 - ${currentItem.orderId}`,
    footer: null,
    onCancel() {
      dispatch({
        type: `${namespace}/hideModal`,
      })
    },
  }

  const handleRefresh = (newQuery) => {
    dispatch(routerRedux.push({
      pathname,
      search: stringify({
        ...query,
        ...newQuery,
      }),
    }))
  }

  const handleView = (record) => {
    dispatch({
      type: `${namespace}/showModal`,
      payload: {
        currentItem: record
      },
    })
  }

  const onProductClick = (product) => {
    dispatch(routerRedux.push({
      pathname: `/ticket/${product.productId}`,
    }))
  }

  const onLogout = () => {
    dispatch({
      type: 'app/logout',
    })
  }

  const listProps = {
    scroll: {x: 800},
    rowKey: "orderId",
    columns,
    dataSource: list,
    loading: loading.effects[`${namespace}/query`],
    pagination,
    location,
    onChange(page) {
      handleRefresh({
        page: page.current,
        pageSize: page.pageSize,
      })
    },
  }

  return (
    <div className={styles['page-list']}>
      <h1>网上售票</h1>
      <Divider/>
      <div className={styles['product-list']}>
        {
          products.map(product => <Card key={product.productId} onClick={() => onProductClick(product)} hoverable
                                        cover={<img alt="example" src={ticketImage}/>}>
            <Card.Meta title={<div>{product.title}
              <div className="price"><span>{product.price}</span> 元</div>
            </div>} description="上海辰山植物园"/>
            <div className={styles['product-tag']}>{product.title}</div>
          </Card>)
        }
      </div>
      {
        user && <Fragment>
          <div className={styles.legend}>
            已购票列表
            <div style={{float: 'right', paddingRight: 50}}>
              您好：{user.phoneNo} &nbsp; <Button onClick={onLogout}>退出</Button>
            </div>
          </div>
          <Table{...listProps}/>
        </Fragment>
      }
      {modalVisible && <Modal {...modalProps}>
        <Info item={currentItem}/>
      </Modal>}
    </div>

  )
}

export default connect(({ticket, app, loading}) => ({
  loading,
  model: ticket,
  app,
}))(Component)
